import { request } from '../../request'

// 结算统计-结算项目明细
export function getSettleStatisticsDetail(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleStatisticsList',
    method: 'post',
    data
  })
}

// 结算统计-结算明细tab数量
export function getSettleStatisticsNum(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleStatisticsCount',
    method: 'post',
    data
  })
}

// 结算项目明细导出Excel
export function downloadProjectDetailExcel(data) {
  return request({
    url: '/wjsettlement/center/projectExcel/downloadFeeSettlementStatExcel',
    method: 'post',
    data
  });
}

// 结算项目明细导出PDF
export function downloadProjectDetailPDF(data) {
  return request({
    url: '/wjsettlement/center/projectExcel/downloadFeeSettlementStatPDF',
    method: 'post',
    data
  });
}